import { render, staticRenderFns } from "./SalesIndex.vue?vue&type=template&id=053dcb1e"
import script from "./SalesIndex.vue?vue&type=script&lang=ts"
export * from "./SalesIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports